import React from 'react';
import classnames from 'classnames';

import MediaMdDown from 'components/Responsive/MediaMdDown';
import EquippedShortlist from 'components/Possessions/components/EquippedShortlist';

export default function OutfitControlComponent({
  isChanging,
  isExpanded,
  onChange,
  onToggleExpanded,
  outfits,
  selectedOutfit,
}: Props) {
  return (
    <div className="outfit-control">
      <select
        className={classnames(
          'form__control js-selector possessions__outfit-selector',
          isChanging && 'possessions__outfit-selector--is-changing',
        )}
        name="outfit"
        value={selectedOutfit.id}
        onChange={onChange}
      >
        {outfits.map(({ id, name }) => <option key={id} value={id}>{name}</option>)}
      </select>
      <MediaMdDown>
        <EquippedShortlist />
      </MediaMdDown>
      <div className="possessions__inventory-switcher">
        <p>
          <button
            className="button button--primary"
            onClick={onToggleExpanded}
            type="button"
          >
            {isExpanded ? 'STANDARD' : 'EXPANDED'}
          </button>
        </p>
      </div>
    </div>
  );
}

interface Props {
  isChanging: boolean,
  isExpanded: boolean,
  onChange: (_e: any) => void,
  onToggleExpanded: (_e: any) => void,
  outfits: { name: string, id: number }[],
  selectedOutfit: { name: string, id: number },
}
